<button *ngIf="options.show && !options.roles" (click)="onClick($event)" [ngClass]="options.cssClasses" class="btn "
    data-bs-toggle="tooltip" data-bs-placement="top" [title]="options.tooltip">
    <i *ngIf="options.icon" class="{{options.icon}}"></i>
    <p class="mb-0" *ngIf="options.text"> {{options.text}}</p>
</button>
<button *ngIf="options.show && options.roles && options.roles.length > 0" (click)="onClick($event)" [ngClass]="options.cssClasses" class="btn "
    data-bs-toggle="tooltip" data-bs-placement="top" [title]="options.tooltip">
    <i *ngIf="options.icon" class="{{options.icon}}"></i>
    <p class="mb-0" *ngIf="options.text"> {{options.text}}</p>
</button>